import { InjectionToken } from '@angular/core';

export const NGX_FFM_TOKEN = new InjectionToken(
  'NGX_FFM_TOKEN'
);
